import actionTypes from '../actionTypes';
import moment from 'moment';

const initialState = {
  info: {
    customerNumber: '',
    customerName: '',
    startTime: '',
    currentTime: '',
    sessionId: '',
    agentInfo: {},
    agentId: '',
    custInfo: {},
    custId: '',
    monitorState: ''
  },
  callList: []
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.CALL_INFO: {
      console.log('Update call Info', action );
      newState.monitorState = "";
      if (action.payload && action.payload.data && action.payload.data.data && action.payload.userId ) {
        let callData = action.payload.data;
        let userId = action.payload.userId;
        if( callData.transferCall && callData.transferCall == "Transfer" ) {
          if( callData.transferCallData  ){
            newState.info.sessionId = callData.transferCallData.sessionId;
            newState.info.agentId = callData.transferCallData.Id;
            newState.info.initdate = moment( callData.transferCallData.startTime ).format("DD-MM-YYYY");
            newState.transferCall = "Transfer";
          }
        } else if( callData.monitorCall && callData.monitorCall == "Monitor" ) {
          if( callData.monitorCallData  ){
            newState.info.sessionId = callData.monitorCallData.sessionId;
            newState.info.agentId = callData.monitorCallData.Id;
            newState.info.initdate = moment( callData.monitorCallData.startTime ).format("DD-MM-YYYY");
            newState.monitorState = "Monitor";
          }
        } else {
          // call info for 
          let callInfo = callData.data.extraData || callData.data.callInfo || {};
          let agentInfo = {};  
          if( callInfo.call1 && callInfo.call1.userId == userId ){
            agentInfo = callInfo.call1;
          } else if( callInfo.call2 && callInfo.call2.userId == userId ){
            agentInfo = callInfo.call2;
          } else if( callInfo.calls && callInfo.calls.length ){
            for (let data of callInfo.calls) {
              if( data.userId == userId  ) {
                agentInfo = data;
                break;
              }
            }
          }
          newState.info.isTransferInitialed = agentInfo.isTransferInitialed || false;
          newState.info.sessionId = agentInfo.sessionId || "";
          newState.info.agentId = agentInfo.Id || "";
          newState.info.initdate = agentInfo.startTime ? moment( agentInfo.startTime ).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY"); 

          // get customer
          let customerInfo = {};
          if( callInfo.call1 && callInfo.call1.isCustomer ){
            newState.info.custId = callInfo.call1;
          } else if( callInfo.call2 && !callInfo.call2.isCustomer ){
            customerInfo = callInfo.call2;
          } else if( callInfo.calls  ){
            for (let data of callInfo.calls) {
              if( data.isCustomer  ) {
                customerInfo = data;
                break;
              }
            }
          }
          newState.info.custId = customerInfo.Id || "";
        }
      }
      return newState;
    }
    case actionTypes.CALL_List:
      newState.callList = action.payload.data;
      return newState;
    case actionTypes.CALL_CUSTOMER_NUMBER:
      newState.customerNumber = action.payload.data;
      return newState;
    case actionTypes.CALL_CUSTOMER_NAME:
      newState.customerName = action.payload.data;
      return newState;
    case actionTypes.CALL_START_TIME:
      newState.startTime = action.payload.data;
      return newState;
    case actionTypes.CALL_CURRENT_TIME:
      newState.currentTime = action.payload.data;
      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/call.reducer.js